"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginPaddingStyles = marginPaddingStyles;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _createMediaQueriesKeys = _interopRequireDefault(require("../../utils/createMediaQueriesKeys"));

var mediaKeysCache;
var cachedSpaceParser;
var SUPPORTED_SPACE_PROP_KEY = ['margin', 'marginY', 'marginX', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'padding', 'paddingY', 'paddingX', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];

function marginPaddingStyles(props) {
  var theme = props.theme;
  var space = theme.space;

  if (!mediaKeysCache) {
    mediaKeysCache = (0, _createMediaQueriesKeys.default)(theme.breakPoints);
  }

  if (!cachedSpaceParser) {
    cachedSpaceParser = spaceParser(space);
  }

  var getSpaceValue = cachedSpaceParser;
  var newStyle = {};

  var _loop = function _loop(i) {
    var key = SUPPORTED_SPACE_PROP_KEY[i];
    var raw = props[key];

    if (typeof raw === 'function' || !raw) {
      return "continue";
    }

    if (Array.isArray(raw)) {
      // convert to responsive
      mediaKeysCache.forEach(function (mediaKey, index) {
        if (raw[index] && !newStyle[mediaKey]) {
          newStyle[mediaKey] = {};
        }

        if ((0, _typeof2.default)(newStyle[mediaKey]) === 'object') {
          Object.assign(newStyle[mediaKey], getSpaceValue(key, raw[index]));
        }
      });
    } else {
      // combine style
      Object.assign(newStyle, getSpaceValue(key, raw));
    }
  };

  for (var i = 0; i < SUPPORTED_SPACE_PROP_KEY.length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return newStyle;
}

var spaceParser = function spaceParser(spaceScale) {
  return function (key, value) {
    // none is mapped to 0, so || won't work, it must be undefined check.
    var spaceValue = spaceScale[value] !== undefined ? spaceScale[value] : value;

    switch (key) {
      case 'padding':
        {
          return {
            padding: spaceValue
          };
        }

      case 'paddingX':
        {
          return {
            paddingLeft: spaceValue,
            paddingRight: spaceValue
          };
        }

      case 'paddingY':
        {
          return {
            paddingTop: spaceValue,
            paddingBottom: spaceValue
          };
        }

      case 'margin':
        {
          return {
            margin: spaceValue
          };
        }

      case 'marginX':
        {
          return {
            marginLeft: spaceValue,
            marginRight: spaceValue
          };
        }

      case 'marginY':
        {
          return {
            marginTop: spaceValue,
            marginBottom: spaceValue
          };
        }

      case 'paddingLeft':
      case 'paddingTop':
      case 'paddingRight':
      case 'paddingBottom':
      case 'marginLeft':
      case 'marginTop':
      case 'marginRight':
      case 'marginBottom':
        {
          return (0, _defineProperty2.default)({}, key, spaceValue);
        }

      default:
        {
          return (0, _defineProperty2.default)({}, key, value);
        }
    }
  };
};